import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import CommandPalette from "@/components/CommandPalette";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
    const [paletteOpen, setPaletteOpen] = useState(false);
    return (
        <div className="flex h-screen bg-zinc-50 text-zinc-950" data-testid="app-shell">
            <Sidebar />
            <div className="flex flex-1 flex-col overflow-hidden">
                <Topbar onOpenCommand={() => setPaletteOpen(true)} />
                <main className="flex-1 overflow-y-auto">
                    <Outlet />
                </main>
            </div>
            <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
            <Toaster position="bottom-right" />
        </div>
    );
}
